var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vuetify-money',_vm._b({attrs:{"options":_vm.options},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},'vuetify-money',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }